// import './utils/wdyr';

import 'core-js/actual/url-search-params';
import 'core-js/actual/object/group-by';

import React from 'react';
import * as Sentry from '@sentry/react';

import Client from './Client';
import Server from './Server';

if (process.env.NODE_ENV !== 'development') {
  Sentry.init({
    environment: process.env.NODE_ENV,
    dsn: 'https://1aeff8a521a04abc880c7354d7745535@o1194184.ingest.sentry.io/6362490',
    denyUrls: [/nr-rum.*\.js/i],
  });
}

function App(props) {

  if (typeof window === 'undefined') {
    return <Server {...props}/>;
  }
  return <Client {...props}/>;
}

export default App;
